// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"375":"repo","414":"image","529":"package","543":"data","746":"catalogue","878":"generic"}[chunkId] + "." + {"375":"8061eb6c","414":"9426e6a6","529":"f73975f3","543":"1974ef4d","746":"321bbe38","878":"97548dd8"}[chunkId] + ".js";
};